import { DirectiveLocation, GraphQLDirective } from 'graphql';

export enum Directives {
	CUSTOM = 'custom',
}

export const CustomDirective = new GraphQLDirective({
	name: Directives.CUSTOM,
	locations: [DirectiveLocation.QUERY, DirectiveLocation.MUTATION],
});
